import * as R from 'ramda';
import axios, { AxiosHeaders } from 'axios';
import liff from '@line/liff';
// import {v4 as uuidv4} from 'uuid';
import Constants from '@utils/constants';
import { handleRecaptchaApiMessage } from '@utils/turnstile';

function CustomException(error: Error): {
    endpoint: string;
    statusText: string;
    message: string;
    status: number;
    data: null;
} {
    return {
        endpoint: R.pathOr('', ['response', 'config', 'url'], error),
        statusText: R.pathOr('', ['response', 'statustext'], error),
        message: R.pathOr('', ['message'], error),
        status: R.pathOr(500, ['response', 'status'], error),
        data: R.pathOr(null, ['response', 'data'], error),
    };
}

/** Middleware / captcha endpoints may return HTTP 200 with success:false when blocked. */
const guardRecaptchaBlocked = (response: { data?: { message?: string } }) => {
    handleRecaptchaApiMessage(response?.data?.message);
    return response;
};


axios.interceptors.response.use(
    function (response) {
        guardRecaptchaBlocked(response);
        return response;
    },
    function (error) {
        handleRecaptchaApiMessage(error?.response?.data?.message);
        if (error.response && error.response.status === 401) {
            let utm = localStorage.getItem('utmParams')
            sessionStorage.clear();
            localStorage.clear();
            if (liff.isInClient()) {
                alert(`https://liff.line.me/${Constants.LIFF_ID}${utm}`)
                if (utm) {
                    window.location.href = `https://liff.line.me/${Constants.LIFF_ID}${utm}`;
                } else {
                    window.location.href = `https://liff.line.me/${Constants.LIFF_ID}`;
                }
            } else {
                if (utm) {
                    window.location.href = `/${utm}`;
                } else {
                    window.location.href = `/`;
                }
            }
        }
        return Promise.reject(error);
    }
);



const get = async (endpoint: String, headers?: Object, options = {}) => {
    
    const token = sessionStorage?.getItem('accessKey');

    const commonHeaders: any = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Api-Key': import.meta.env.VITE_API_KEY
    };

    const commonOptions: any = {
        method: 'GET',
        responseType: 'json' as ResponseType,
        ...options
    };


    return await axios.get(`${Constants.BASE_URL}${endpoint}`, {
        ...commonOptions,
        headers: new AxiosHeaders({ ...commonHeaders, ...headers })
    })
        .then(response => { return response; })
        .catch((error) => {
            throw CustomException(error);
        });
};

const post = async (endpoint: String, body?: Object, headers?: Object, options = {}) => {
    const token = sessionStorage?.getItem('accessKey');
    let commonHeaders: any = {};

    const isFormData = body instanceof FormData;

    if (endpoint == 'auth/login') {
        commonHeaders = {
            'Content-Type': 'application/json',
            'X-Api-Key': import.meta.env.VITE_API_KEY
        };
    } else {
        commonHeaders = {
            ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
            'Authorization': `Bearer ${token}`,
            'X-Api-Key': import.meta.env.VITE_API_KEY
        };
    }

    const commonOptions: any = {
        method: 'POST',
        responseType: 'json',
        ...options
    };

    return axios.post(`${Constants.BASE_URL}${endpoint}`, body,
        {
            ...commonOptions,
            headers: { ...commonHeaders, ...headers }
        })
        .then(response => { return response; })
        .catch((error) => {
            throw CustomException(error);
        });
};

const put = async (endpoint: String, body?: Object, headers?: Object, options = {}) => {

    const token = sessionStorage?.getItem('accessKey');
    const commonHeaders: any = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Api-Key': import.meta.env.VITE_API_KEY
    };

    const commonOptions: any = {
        method: 'PUT',
        responseType: 'json',
        ...options
    };

    return axios.put(`${Constants.BASE_URL}${endpoint}`, body,
        {
            ...commonOptions,
            headers: { ...commonHeaders, ...headers }
        })
        .then(response => { return response; })
        .catch((error) => {
            throw CustomException(error);
        });
};

function exportFunctions() {
    let callGet = get;
    let callPost = post;
    let callPut = put;
    return {
        callGet,
        callPost,
        callPut

    };
}

export default exportFunctions();


